import React from 'react';

export default function ToastContainer({ toasts, onRemove }) {
  if (!toasts.length) return null;

  return (
    <div className="toast-container">
      {toasts.map(t => (
        <div
          key={t.id}
          className={`toast toast-${t.type}${t.removing ? ' toast-removing' : ''}`}
        >
          <span className="toast-icon">
            {t.type === 'success' && '✓'}
            {t.type === 'error' && '✕'}
            {t.type === 'info' && 'ℹ'}
          </span>
          <span className="toast-message">{t.message}</span>
          {t.action && (
            <button
              className="toast-action"
              onClick={() => {
                try { t.action.onClick(); } catch (_) { /* ignore */ }
                onRemove(t.id);
              }}
              style={{
                background: 'transparent',
                border: '1px solid currentColor',
                color: 'inherit',
                padding: '4px 10px',
                borderRadius: 4,
                cursor: 'pointer',
                marginLeft: 8,
                fontSize: '0.85rem',
                fontWeight: 500,
              }}
            >
              {t.action.label}
            </button>
          )}
          <button className="toast-close" onClick={() => onRemove(t.id)}>×</button>
        </div>
      ))}
    </div>
  );
}
